import { WatchQueryFetchPolicy } from '@apollo/client';
import { useFetchQuantifyChartData } from '@modules/quantify/hooks/useFetchQuantifyChartData';
import { useFetchQuantifyTableData } from '@modules/quantify/hooks/useFetchQuantifyTableData';
import { useCallback } from 'react';

interface UseFetchQuantifyReportOptions {
  fetchPolicy?: WatchQueryFetchPolicy;
  isInitialFetch?: boolean;
  shouldFetchChartData?: boolean;
  shouldFetchTableData?: boolean;
}

export function useFetchQuantifyReport({
  shouldFetchChartData = true,
  shouldFetchTableData = true,
  ...options
}: UseFetchQuantifyReportOptions = {}) {
  const [fetchQuantifyTableData] = useFetchQuantifyTableData(options);
  const [fetchQuantifyChartData] = useFetchQuantifyChartData(options);

  const fetchQuantifyReport = useCallback(() => {
    const promises: Promise<void>[] = [];

    if (shouldFetchChartData) {
      promises.push(fetchQuantifyChartData());
    }

    if (shouldFetchTableData) {
      promises.push(fetchQuantifyTableData());
    }

    return Promise.all(promises);
  }, [
    shouldFetchChartData,
    shouldFetchTableData,
    fetchQuantifyChartData,
    fetchQuantifyTableData,
  ]);

  return fetchQuantifyReport;
}
